var _line, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidePole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 440,
    viewBox: "0 0 32 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.6211,
    y1: 16,
    x2: 15.6211,
    y2: 424,
    stroke: "#E21F2C",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5676,
    cy: 16,
    rx: 15.5676,
    ry: 16,
    fill: "#E21F2C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5676,
    cy: 424,
    rx: 15.5676,
    ry: 16,
    fill: "#E21F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidePole);
export default __webpack_public_path__ + "static/media/side-pole.a7159981cb45e057556c03ae47557599.svg";
export { ForwardRef as ReactComponent };